<style src="./module_1.scss" lang="scss" scoped></style>
<template src="./module_1.html"></template>

<script>
  import anime from 'animejs';
  import animations from '../../assets/js/animations';
  import Emotion_Expand from './emotion_expand/emotion_expand';
  import * as contentful from 'contentful';

  export default {
    components: {
      'emotion-expand': Emotion_Expand
    },
    data() {
      return {
        // modal
        modalActive: false,
        modalInd: 0,
        modalText: [
          [
            "Before you launch the animation, please assign the following speaking roles to students in the classroom. Readers will know it is their turn to speak when their character’s icon appears to the left of the text box.",
            "Student One: Aye", "Student Two: Ria"
          ]
        ],
        modalStyle: {
          'background': '#7BADD6'
        },
        //
        lab_ready_state: {
          doors_active: true,
          doors_visible: true
        },
        aye_state: ["deactivated"],
        aye_styles: [],
        aye_activated: false,
        lab_state: ['blueprint'],
        lab_interaction: false,
        lab_info_text: "activation complete",
        lab_sound: null,
        emotional_colors: false,
        active_text: null,
        text: null,
        interaction_state: "activate",
        ria_speaking: false,
        control_panel_active: false,
        modal_active: false,
        modal_ready: false,
        selected_slice: '',
        current_slice: '',
        emotion_expand_active: false,
        module_complete: false
      }
    },
    mounted() {

      // open initial modal
      this.modalActive = true

      this.lab_sounds = new Audio('static/audio/module_1/lab_background.mp3');
      this.lab_sounds.volume = 0.15;
      // this.lab_sounds.play();

      const content_client = contentful.createClient({
        space: process.env.SPACE_ID,
        accessToken: process.env.CMS_TOKEN
      });

      content_client.getEntries({
        content_type: 'module',
        'fields.module_number': 1
      }).then((response) => {
        // console.log(response);
        this.text = response.items[0].fields.module_text.map((data) => {
          let temp;
          if (data.fields.speaker) {
            temp = {
              id: data.fields.id,
              speaker: data.fields.speaker,
              string: data.fields.text.replace(/\n/g, "<br />")
            }
          } else {
            temp = {
              id: data.fields.id,
              string: data.fields.text.replace(/\n/g, "<br />")
            }
          }
          return temp;
        });
        this.active_text = this.text[0];
      }).catch(console.error);

      anime(animations.fingerprint);

      const graph_anchors = [{
          from_y: 326,
          to_y: 285
        },
        {
          from_y: 243,
          to_y: 305
        },
        {
          from_y: 305,
          to_y: 264
        },
        {
          from_y: 285,
          to_y: 326
        },
        {
          from_y: 325,
          to_y: 285
        }
      ];

      const graph_path_data_from = 'M929.12 324.54l46.14 -39.52 48.08 19.8 46.97 -62.55 47.24 84.27';
      const graph_path_data_to = 'M929.12 284.54l47.14 41.48 47.08 -62.2 46.97 41.45 47.24 -20.73';

      anime({
        targets: '.line_graph_first_anchor',
        cy: [{
            value(el, i) {
              return graph_anchors[i].to_y;
            },
            delay: 5000
          },
          {
            value(el, i) {
              return graph_anchors[i].from_y;
            },
            delay: 5000
          }
        ],
        easing: 'easeOutCubic',
        loop: true
      });

      anime({
        targets: '#line_graph_first_path',
        d: [{
            value: graph_path_data_to,
            delay: 5000
          },
          {
            value: graph_path_data_from,
            delay: 5000
          }
        ],
        easing: 'easeOutCubic',
        loop: true
      });

      let motion_paths = {
        path_1: anime.path('#radar_path_1'),
        path_2: anime.path('#radar_path_2'),
        path_3: anime.path('#radar_path_3')

      }

      anime({
        targets: '#radar_point_1',
        cy: motion_paths.path_1('y'),
        cx: motion_paths.path_1('x'),
        easing: 'linear',
        duration: 10000,
        loop: true
      });

      anime({
        targets: '#radar_point_2',
        cy: motion_paths.path_2('y'),
        cx: motion_paths.path_2('x'),
        easing: 'linear',
        duration: 7000,
        loop: true
      });

      anime({
        targets: '#radar_point_3',
        cy: motion_paths.path_3('y'),
        cx: motion_paths.path_3('x'),
        easing: 'linear',
        duration: 5000,
        loop: true
      });


    },
    destroyed() {
      delete this.lab_sounds;
    },
    methods: {
      // close modal
      closeModal() {
        this.modalActive = false
      },
      //
      toggle_modal() {
        if (this.modal_active) {
          this.modal_active = false;
          this.modal_ready = false;
        } else {
          this.modal_active = true;
          this.modal_ready = true;
        }
      },
      replay() {
        this.timeline.restart();
      },
      slice_select(string) {
        this.emotion_expand_active = true;
        this.selected_slice = string;
      },
      slice_over(string) {
        this.current_slice = string;
      },
      slice_leave() {
        this.current_slice = '';
      },
      close_emotion_expand() {
        this.emotion_expand_active = false;
      },
      close_modal() {
        this.modal_active = false;
        this.modal_ready = false;
        this.text_update();
      },
      ria_speech(count, delay) {
        let temp = count - 1;
        if (temp > 0) {
          this.ria_speaking = true;
          setTimeout(() => {
            this.ria_speaking = false;
            setTimeout(() => {
              this.ria_speech(temp, delay);
            }, delay);
          }, delay);
        }
      },
      text_update() {

        let new_id = this.text.indexOf(this.active_text) + 1;
        if (this.control_panel_active && !this.modal_ready) {
          this.control_panel_active = false;

          if (this.text[new_id]) {
            this.active_text = this.text[new_id];

            if (this.active_text.speaker) {
              let current_speaker = this.active_text.speaker.toLowerCase();

              if (current_speaker == 'ria') {
                this.ria_speech(5, 500);
              }
            }

          }

          let timeline = anime.timeline();

          switch (new_id) {
            case 1:
              timeline.add({
                targets: '#ria',
                left: ['100%', '55%'],
                translateY: [{
                    value: '0'
                  },
                  {
                    value: '20px'
                  },
                  {
                    value: '0'
                  },
                  {
                    value: '20px'
                  },
                  {
                    value: '0'
                  },
                  {
                    value: '20px'
                  },
                  {
                    value: '0'
                  }
                ],
                duration: 2000,
                easing: 'linear'
              }).add({
                targets: '#ria_right_arm_hand',
                rotate: '100deg',
                easing: 'easeOutCubic',
                offset: '-=1200'
              }).add({
                targets: '#ria_right_arm_hand',
                rotate: [{
                    value: '100deg',
                    easing: 'linear',
                    duration: 300
                  },
                  {
                    value: '120deg',
                    easing: 'linear',
                    duration: 300
                  },
                  {
                    value: '100deg',
                    easing: 'linear',
                    duration: 300
                  },
                  {
                    value: '120deg',
                    easing: 'linear',
                    duration: 300
                  },
                  {
                    value: '100deg',
                    easing: 'linear',
                    duration: 300
                  }
                ],
                complete: () => {
                  // anime(animations.ria_sway);
                  this.control_panel_active = true;
                }
              })
              break;
            case 2:
              this.control_panel_active = true;
              break;
            case 3:
              this.control_panel_active = false;
              this.lab_interaction = true;
              anime({
                targets: '.aye_activation_button',
                scale: 1.25,
                easing: 'linear',
                direction: 'alternate',
                loop: true
              });
              break;
            case 4:
              this.control_panel_active = true;
              break;
            case 5:
              anime({
                targets: '#aye_orb',
                fill: [{
                    value: '#F5A623'
                  },
                  {
                    value: '#F8E71C'
                  },
                  {
                    value: '#7ED321'
                  },
                  {
                    value: '#4A90E2'
                  },
                  {
                    value: '#9013FE'
                  },
                  {
                    value: '#D0021B'
                  },
                  {
                    value: '#4A90E2'
                  }
                ],
                loop: true,
                easing: 'linear',
                duration: 3000
              });

              timeline.add({
                targets: '#aye',
                opacity: 0,
                easing: 'linear',
                duration: 300,
                complete: () => {
                  this.aye_state = ['unsure'];
                  this.aye_styles = {
                    transform: 'scale(-3, 3)'
                  };
                }
              }).add({
                targets: '#aye',
                left: ['18%', '45%'],
                top: ['29%', '35%'],
                duration: 100,
                easing: 'linear'
              }).add({
                targets: '#ria_right_arm_hand',
                rotate: '0deg',
                easing: 'easeOutCubic'
              }).add({
                targets: '#emotional_colors',
                opacity: 1,
                duration: 500,
                easing: 'linear',
                offset: '-=1000',
                complete() {
                  let woah_sound = new Audio('static/audio/module_1/woah.mp3');
                  woah_sound.play();
                }
              }).add({
                targets: '#aye',
                opacity: [0, 1],
                easing: 'linear',
                duration: 500,
                offset: '-=500'
              }).add({
                targets: '#aye_right_arm',
                rotate: '20deg',
                duration: 500,
                easing: 'easeOutCubic'
              }).add({
                targets: '#aye_right_arm_hand',
                rotate: '130deg',
                offset: '-=500',
                duration: 500,
                easing: 'easeOutCubic'
              }).add({
                targets: '#aye_left_arm',
                rotate: '20deg',
                offset: '-=500',
                duration: 500,
                easing: 'easeOutCubic'
              }).add({
                targets: '#aye_left_arm_hand',
                rotate: '130deg',
                offset: '-=500',
                duration: 500,
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 6:
              timeline.add({
                targets: '#aye_right_arm, #aye_right_arm_hand, #aye_left_arm, #aye_left_arm_hand',
                rotate: '0deg',
                duration: 500,
                easing: 'easeOutCubic'
              }).add({
                targets: '#emotional_colors',
                opacity: [1, 0],
                easing: 'linear',
                duration: 500,
                complete: () => {
                  anime.remove('#emotional_colors, #aye_orb');
                  this.emotional_colors = false;
                  this.aye_state = ['unsure', 'orange'];
                }
              }).add({
                targets: '#lab_container_2',
                scaleY: '1',
                easing: 'easeOutCubic',
                begin() {
                  let tube_sound = new Audio('static/audio/module_1/tube.wav');
                  tube_sound.volume = 0.25;
                  tube_sound.play();
                }
              }).add({
                targets: '#aye',
                left: ['45%', '35%'],
                scale: '-3, 3',
                translateY: [{
                    value: '10px'
                  },
                  {
                    value: '0'
                  }
                ],
                offset: '-=1000',
                easing: 'easeOutCubic'
              }).add({
                targets: '#ria_right_arm',
                rotate: '60deg',
                duration: 500,
                easing: 'easeOutCubic'
              }).add({
                targets: '#ria_right_arm_hand',
                rotate: [{
                    value: '40deg'
                  },
                  {
                    value: '20deg'
                  },
                  {
                    value: '40deg'
                  },
                  {
                    value: '20deg'
                  },
                  {
                    value: '40deg'
                  },
                  {
                    value: '20deg'
                  }
                ],
                duration: 2000,
                easing: 'linear',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 7:
              this.control_panel_active = true;
              this.aye_state = ['neutral', 'orange'];
              break;
            case 8:
              timeline.add({
                targets: '#aye_left_arm_hand',
                rotate: '140deg',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 9:
              timeline.add({
                targets: '#ria',
                left: ['55%', '75%'],
                translateY: [{
                    value: '20px'
                  },
                  {
                    value: '0'
                  },
                  {
                    value: '20px'
                  },
                  {
                    value: '0'
                  }
                ],
                easing: 'easeOutCubic'
              }).add({
                targets: '#ria_right_arm',
                rotate: '0deg',
                offset: '-=1000',
                easing: 'easeOutCubic'
              }).add({
                targets: '#ria_right_arm_hand',
                rotate: '60deg',
                easing: 'easeOutCubic'
              }).add({
                targets: '#aye',
                left: ['35%', '15%'],
                scale: '-3, 3',
                translateY: [{
                    value: '10px'
                  },
                  {
                    value: '0'
                  },
                  {
                    value: '10px'
                  },
                  {
                    value: '0'
                  }
                ],
                easing: 'easeOutCubic',
                offset: '-=1700',
                complete: () => {
                  this.control_panel_active = true;
                }
              });

              this.aye_state = ['unsure', 'blue'];
              this.lab_state = ['sensor_report'];
              this.lab_interaction = false;

              anime({
                targets: '.report_bar',
                scaleY: [0, 1],
                delay: function (el, i, l) {
                  let random = anime.random(1, l);
                  return random * 100;
                },
                easing: 'easeOutCubic',
                duration: 2000
              });

              anime({
                targets: '#report_heart_3, #report_power_3, #report_gear_3',
                strokeDashoffset: (el, i) => {
                  return [anime.setDashoffset, (i + 1) * 60]
                },
                delay: (el, i) => {
                  return i * 300;
                },
                duration: 2500,
                easing: 'easeOutCubic'
              });

              break;
            case 10:
              timeline.add({
                targets: '#aye_left_arm_hand',
                rotate: '0deg',
                easing: 'easeOutCubic'
              }).add({
                targets: '#ria_right_arm_hand',
                rotate: '0deg',
                easing: 'easeOutCubic'
              }).add({
                targets: '#ria_right_arm',
                rotate: '0deg',
                easing: 'easeOutCubic',
                offset: '-=1000',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              this.lab_state = ['lab_chip', 'blueprint', 'lab_info'];
              this.lab_info_text = 'emotion chip';
              this.aye_state = ['neutral', 'green'];
              break;
            case 11:
              this.control_panel_active = true;
              this.lab_state = ['school', 'blueprint', 'lab_info'];
              this.lab_info_text = 'high school';
              this.aye_state = ['smile', 'purple'];
              break;
            case 12:
              anime({
                targets: '#aye_right_arm_hand',
                rotate: '100deg',
                duration: 500,
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 13:
              this.aye_state = ['smile', 'blue'];
              this.lab_state = ['sensor_report'];
              this.lab_info_text = 'emotion chip';
              anime({
                targets: '#aye_right_arm_hand',
                rotate: '0deg',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 14:
              timeline.add({
                targets: '#ria_right_arm',
                rotate: '40deg',
                duration: 300,
                easing: 'easeOutCubic'
              }).add({
                targets: '#ria_right_arm_hand',
                rotate: '40deg',
                offset: '-=300',
                duration: 500,
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              this.modal_ready = true;
              break;
            case 15:
              this.control_panel_active = true;
            case 16:
              this.aye_state = ['smile', 'purple'];

              timeline.add({
                targets: '#ria_right_arm',
                rotate: '0deg',
                duration: 500,
                easing: 'easeOutCubic'
              }).add({
                targets: '#ria_right_arm_hand',
                rotate: '0deg',
                offset: '-=500',
                easing: 'easeOutCubic'
              }).add({
                targets: '#aye_right_arm',
                rotate: '20deg',
                duration: 500,
                offset: '-=1000',
                easing: 'easeOutCubic'
              }).add({
                targets: '#aye_right_arm_hand',
                rotate: '80deg',
                duration: 500,
                offset: '-=1000',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 17:
              this.aye_state = ['unsure', 'orange'];

              timeline.add({
                targets: '#aye_right_arm, #aye_right_arm_hand',
                rotate: '0deg',
                duration: 500,
                easing: 'easeOutCubic'
              }).add({
                targets: '#aye_left_arm_hand',
                rotate: '130deg',
                duration: 500,
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 18:
              this.modal_ready = true;
              this.aye_state = ['neutral', 'orange'];
              anime({
                targets: '#aye_left_arm_hand',
                rotate: '0deg',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 19:
              this.aye_state = ['smile', 'green'];
              anime({
                targets: '#ria_right_arm_hand',
                rotate: '100deg',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 20:
              this.control_panel_active = true;
              this.lab_state = ['newspaper', 'blueprint', 'lab_info'];
              this.lab_info_text = 'school newspaper';
              break;
            case 21:
              anime({
                targets: '#ria_right_arm_hand',
                rotate: '0deg',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 22:
              this.control_panel_active = true;
              break;
            case 23:
              anime({
                targets: '#ria_right_arm_hand',
                rotate: '100deg',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 24:
              this.aye_state = ['unsure', 'orange'];
              anime({
                targets: '#ria_right_arm_hand',
                rotate: '0deg',
                easing: 'easeOutCubic'
              });

              anime({
                targets: '#aye_left_arm_hand',
                rotate: '130deg',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 25:
              anime({
                targets: '#ria_right_arm',
                rotate: '60deg',
                easing: 'easeOutCubic',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
              break;
            case 26:
              anime({
                targets: '#ria_right_arm, #aye_left_arm_hand',
                rotate: '0deg',
                easing: 'easeOutCubic'
              });


              timeline.add({
                targets: '#aye',
                left: ['15%', '110%'],
                scale: '-3, 3',
                translateY: [{
                    value: '10px'
                  },
                  {
                    value: '0'
                  },
                  {
                    value: '10px'
                  },
                  {
                    value: '0'
                  },
                  {
                    value: '10px'
                  },
                  {
                    value: '0'
                  },
                  {
                    value: '10px'
                  },
                  {
                    value: '0'
                  },
                  {
                    value: '10px'
                  },
                  {
                    value: '0'
                  },
                  {
                    value: '10px'
                  },
                  {
                    value: '0'
                  }
                ],
                duration: 5000,
                easing: 'easeOutCubic'
              }).add({
                targets: '#ria',
                left: ['75%', '100%'],
                scaleX: {
                  value: '-1',
                  duration: 1,
                  easing: 'linear'
                },
                translateY: [{
                    value: '20px'
                  },
                  {
                    value: '0'
                  },
                  {
                    value: '20px'
                  },
                  {
                    value: '0'
                  }
                ],
                duration: 2500,
                offset: '-=3000',
                easing: 'easeOutCubic',
                begin: () => {
                  this.lab_ready_state.doors_active = true;
                }
              }).add({
                targets: '#left_door',
                translateX: ['-100%', '0'],
                easing: 'easeOutQuart',
                duration: 2000,
                offset: '-=1000',
                begin: () => {
                  let door_sound = new Audio('static/audio/module_1/door_open.wav');
                  door_sound.play();

                  this.lab_ready_state.doors_visible = true;
                }
              }).add({
                targets: '#right_door',
                translateX: ['100%', '0'],
                duration: 2000,
                offset: '-=2000',
                easing: 'easeOutQuart',
                complete: () => {
                  anime.remove('#fingerprint_1, #fingerprint_2, #fingerprint_3, #fingerprint_4, #fingerprint_5');
                  this.module_complete = true;
                }
              });
              break;

          }
        } else {
          if (new_id == 15 || new_id == 19) {
            this.modal_active = true;
          }
        }
      },
      lab_interaction_handle() {
        if (this.interaction_state == 'activate' && this.aye_activated == false) {
          anime.remove('.aye_activation_button');
          document.querySelector('.aye_activation_button').setAttribute('style', '');
          let activate_timeline = anime.timeline();

          anime({
            targets: '.aye_activation_color',
            width: '100%',
            easing: 'linear',
            duration: '2000',
            complete: () => {
              this.text_update();
            }
          });

          anime(animations.blink);

          activate_timeline.add({
            targets: '#lab_container_light_1',
            fill: '#D0041E',
            duration: 700
          }).add({
            targets: '#lab_container_light_2',
            fill: '#F6D959',
            duration: 700
          }).add({
            targets: '#lab_container_light_3',
            fill: '#7ED320',
            duration: 700
          }).add({
            targets: '#lab_container_2',
            scaleY: 0,
            easing: 'easeOutCubic',
            begin() {
              let tube_sound = new Audio('static/audio/module_1/tube.wav');
              tube_sound.volume = 0.25;
              tube_sound.play();
            }
          }).add({
            targets: '#aye_left_eye, #aye_right_eye, #aye_mouth_unsure',
            opacity: [{
                value: 1,
                easing: 'linear'
              },
              {
                value: 0,
                duration: 0,
                easing: 'linear'
              },
              {
                value: 1,
                duration: 200,
                easing: 'linear'
              },
              {
                value: 0,
                duration: 100,
                easing: 'linear'
              },
              {
                value: 1,
                duration: 500,
                easing: 'linear'
              }
            ],
            complete: () => {
              this.emotional_colors = true;
              document.getElementById('aye_mouth_unsure').setAttribute('style', '');
              this.aye_state = ['unsure', 'deactivated'];
              this.control_panel_active = true;

              anime({
                targets: '#emotional_colors',
                background: [{
                    value: '#4A90E2'
                  },
                  {
                    value: '#9013FE'
                  },
                  {
                    value: '#D0021B'
                  },
                  {
                    value: '#F5A623'
                  },
                  {
                    value: '#F8E71C'
                  },
                  {
                    value: '#7ED321'
                  },
                  {
                    value: '#4A90E2'
                  }
                ],
                loop: true,
                easing: 'linear',
                duration: 3000
              });
            }
          });
          this.aye_activated = true;
        }
      },
      open_lab() {
        if (this.module_complete == false) {
          this.control_panel_active = true;
          this.text_update();

          let door_sound = new Audio('static/audio/module_1/door_open.wav');
          door_sound.play();

          // try putting lab sound here. fixes safari requirement  for all soudns to be tied to a user click event.
          this.lab_sounds.play();

          anime({
            targets: '#left_door',
            translateX: '-100%',
            easing: 'easeOutQuart',
            duration: 2000,
            complete: () => {
              this.lab_ready_state.doors_active = false;
              this.lab_ready_state.doors_visible = false;
            }
          });

          anime({
            targets: '#right_door',
            translateX: '100%',
            duration: 2000,
            easing: 'easeOutQuart'
          });
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// module_1.vue?5166ef94